//import feather from "feather-icons";
//window.feather = feather;
import * as featherIcon from 'feather-icons';
window.featherIcon = featherIcon;

$(function(){
    featherIcon.replace();
});